/**
 * The card a TV-style start shows from app open until the picture appears
 * (owner, 2026-10-12): never a guide flash or a black screen. Display only:
 * no buttons, never focused, never takes a key. LivePage removes it on the
 * first frame in full screen, an error, a timeout, or any button press.
 */
export interface TvStartCardChannel {
  name: string;
  number?: string | number;
  logoUrl?: string;
}

export function TvStartCard({ channel }: { channel: TvStartCardChannel | null }) {
  return (
    <div className="tv-start-card" role="status" aria-live="polite">
      {channel ? (
        <>
          {channel.logoUrl ? <img className="tv-start-card__logo" src={channel.logoUrl} alt="" /> : null}
          <div className="tv-start-card__name">
            {channel.number !== undefined && channel.number !== "" ? <span className="tv-start-card__number">{channel.number}</span> : null}
            {channel.name}
          </div>
          <div className="tv-start-card__note">Tuning…</div>
        </>
      ) : (
        <div className="tv-start-card__note">Starting Live TV…</div>
      )}
    </div>
  );
}
